<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    @click="$emit('click')"
  >
    <q-item-section>
      <q-item-label v-if="label">
        {{ label }}
      </q-item-label>
      <q-item-label
        v-if="caption"
        caption
      >
        {{ caption }}
      </q-item-label>
    </q-item-section>
    <q-item-section side>
      <q-icon
        v-if="icon"
        :name="icon"
        :color="itemColorProp"
        :style="itemStyleProp"
      />
      <q-radio
        v-if="type === 'radio'"
        :color="itemColorProp"
        :model-value="active"
        :val="true"
        :style="itemStyleProp"
        :class="{'color-inherit': hex}"
        class="no-pointer-events"
        dense
      />
      <q-checkbox
        v-else-if="type === 'checkbox'"
        :color="itemColorProp"
        :model-value="active"
        :val="true"
        :style="itemStyleProp"
        :class="{'color-inherit': hex}"
        class="no-pointer-events"
        dense
      />
    </q-item-section>
  </q-item>
</template>

<script>
import itemMixin from 'src/helpers/item'

/**
 * Custom QItem which is displayed inside QSelect
 * Overrides default Quasar implementation
 *
 * Provides support for HEX color options
 */
export default {
  mixins: [itemMixin],
  props: {
    type: {
      type: String,
      default: 'radio'
    },
    hex: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    },
    label: {
      type: String
    },
    caption: {
      type: String
    },
    icon: {
      type: String
    }
  },
  computed: {
    itemStyleProp () {
      return {
        'color': this.hex ? this.color : undefined
      }
    },
    itemColorProp () {
      return !this.hex ? this.color : undefined
    }
  }
}
</script>
